import React, { useEffect } from 'react';
import { Link, useLocation,useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api_domain_config from "@/config/config";
import './index.less';

// 公共的成功页面组件
const SuccessPage = () => {
    const stateParams = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = `${stateParams.state?.title}-个人中心`;
        document.querySelector('meta[name="keywords"]').setAttribute('content',`${stateParams.state?.title}`);
        document.querySelector('meta[name="description"]').setAttribute('content',`${stateParams.state?.title}`);

        //设置5秒后自动跳转首页
        setTimeout(() => {
           //删除当前的用户信息和token
            Cookies.remove("authorization", { domain: api_domain_config.DOMAIN });
            localStorage.removeItem('currentUserInfo');
            localStorage.removeItem('isSignin');
            // navigate('/login', {replace: true})
            // window.location.href = 'https://www.niuxuezhang.cn/test/purchase/buy-remove-watermark-test.html' 
            window.location.href = 'https://www.niuxuezhang.cn/'
        },5000)
    })

    return (
        <div className='comment-model-page'>
            <div className="topContent">
                <h1 className='text-white mb-0 fw-bold text-center'>{stateParams.state?.title}</h1>
            </div>
            <div className='success-content'>
                <div className='container'>
                    <div className='success-form bg-white rounded-3 mx-auto text-center'>
                        <img src="https://images.niuxuezhang.cn/imgs/account-center/success-icon.svg" alt="" />
                        <div className='mt-4 pt-3'>
                            {stateParams.state?.modelText}
                        </div>
                        {/* <Link to={window.location.origin} className='btn btn-primary mt-5 fs-5'>现在登录</Link> */}
                        <Link to={'https://www.niuxuezhang.cn/'} className='btn btn-primary mt-5 fs-5'>现在登录</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuccessPage;